
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/macro-survey-login",
      function () {
        return require("private-next-pages/macro-survey-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/macro-survey-login"])
      });
    }
  